module.exports = __webpack_public_path__ + "static/media/lambo.eb4c2751.png";